// Third payty and libraries
import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@apollo/client';
import { useToasts } from "react-toast-notifications";
import _ from 'lodash';
import { CONFIRM_USER_ACCOUNT, CONFIRM_USER_AUTH } from '../../graphql/userConfirm/mutation';
import LoadingSpinner from '../../components/LoadingSpinner';
import { validateMainLaotianPhoneNumber } from '../../helpers/validatePhone';

// Validation schema using Yup
const validationSchema = Yup.object().shape({
    phone: Yup.string()
        .required('ກະລຸນາຢືນຢັນເບີໂທ ສຳລັບຫລັກຖານການສັ່ງຊື້!')
        .matches(/^\d{8}$/, 'ເບີໂທ ຕ້ອງເປັນຕົວເລກ 0 - 9 ເທົ່ານັ້ນ ບໍ່ໃສ່ 020 ຫລື 20 ດ້ານຫນ້າ'),
    yourFourLuckyNumber: Yup.string()
        .required('ກະລຸນາປ່ອນ ເລກນຳໂຊກຂອງທ່ານ!')
        .matches(/^\d{4}$/, 'ຕ້ອງເປັນຕົວເລກ 0 - 9 ເທົ່ານັ້ນ'),
    
});

export default function UserVerifyIdentity({ setDataUserConfirm, onCloseModalVerifyIdentity, setIsVerifyIdentity, setIsUseLogicstics }) {
    const dataKey = "END_USER_DATA";
    const tokenKey = `END_USER_TOKEN`;
    const { addToast } = useToasts();
    useEffect(() => {
        checkUserAuth();
    }, [tokenKey]);
    //! CHECK AUTH
    const [confirmUserAuthAPI, { loading: confirmUserAuthLoading }] = useMutation(CONFIRM_USER_AUTH);
    const checkUserAuth = async () => {
        try {
            if(confirmUserAuthLoading) return;
            const token = localStorage.getItem(tokenKey);
            if (token) {
                const confirmUserAuthAPIData = await confirmUserAuthAPI({
                    variables: {
                        token: token
                    }
                });
                if (confirmUserAuthAPIData?.data?.confirmUserAuth?.message === "SUCCESS") {
                    setToLocal({
                        data: confirmUserAuthAPIData?.data?.confirmUserAuth?.userConfirm, 
                        token: confirmUserAuthAPIData?.data?.confirmUserAuth?.token
                    });

                    handleAlert("ທ່ານສາມາດເລືອກທີ່ຢູ່ຂອງໄດ້ແລ້ວ", "success");
                    setDataUserConfirm(confirmUserAuthAPIData?.data?.confirmUserAuth?.userConfirm);
                    setIsVerifyIdentity(true);
                    setTimeout(() => {
                        onCloseModalVerifyIdentity();
                    }, 1000);
                    return;
                }else {
                    delFromLocal();
                }
            }
            return;
        } catch (error) {
            console.log("error", error);
            delFromLocal();
            return;
        }
    }

    //! USER CONFIRM
    const [confirmUserAccountAPI, { loading: confirmUserAccountLoading }] = useMutation(CONFIRM_USER_ACCOUNT);
    const confirmUserWeb = async (values) => {
        if (confirmUserAccountLoading) return;
        try {
            // validate phone
            const {phone, yourFourLuckyNumber} = values;
            if (_.isEmpty(phone)) {
                handleAlert("ກະລຸນາປ້ອນເບີໂທ!", "warning");
                return;
            }
            
            if (!validateMainLaotianPhoneNumber(phone)) {
                handleAlert("ກະລຸນາປ້ອນເບີໂທໃຫ້ຖືກຕ້ອງ!", "warning");
                return;
            }
            
            // Lucky number
            if (_.isEmpty(yourFourLuckyNumber)) {
                handleAlert("ກະລຸນາປ້ອນເລກນຳໂຊກ!", "warning");
                return;
            }
            const firstFourDigits = phone.substring(0, 4);
            const lastFourDigits = phone.slice(-4); // Use slice to get the last four digits

            if (firstFourDigits === yourFourLuckyNumber || lastFourDigits === yourFourLuckyNumber){
                handleAlert("(ເລກນຳໂຊຕ້ອງບໍ່ກົງກັບເບີໂທ 4ຕົວນ່າ ແລະ 4ຕົວທ້າຍ)", "error");
                return;
            }

            // CHECK USER CONFIRM
            const dataRequest = {
                phone: phone,
                account: true,
                yourFourLuckyNumber: yourFourLuckyNumber,
                note: "END_USER_ACCOUNT"
            };

            const confirmUserAccountData = await confirmUserAccountAPI({
                variables: {
                    data: dataRequest
                }
            });
            if (confirmUserAccountData?.data?.confirmUserAccount?.message === "SUCCESS") {
                await setToLocal({
                    data: confirmUserAccountData?.data?.confirmUserAccount?.userConfirm, 
                    token: confirmUserAccountData?.data?.confirmUserAccount?.token
                });

                handleAlert("ຢືນຢັນຕົວຕົນ ສຳເລັດ", "success");
            
                setDataUserConfirm(confirmUserAccountData?.data?.confirmUserAccount?.userConfirm);
                setIsVerifyIdentity(true);
                setTimeout(() => {
                    onCloseModalVerifyIdentity();
                }, 1000);
                return;
            }
            throw "error";
        } catch (error) {
            delFromLocal();
            if (error.message === "ເບີໂທຫລືເລກນຳໂຊກບໍ່ຖືກ") {
                handleAlert("ເບີໂທຫລືເລກນຳໂຊກບໍ່ຖືກ", "error");
            } else {
                handleAlert("ຂໍອະໄພ ບໍ່ສາມາດ ຢືນຢັນຕົວຕົນ ກະລຸນາລອງໃຫມ່ພາຍຫລັງ", "error");
            }
            console.log("ERROR_confirmUserWeb: ", error);
        }
    };

    const setToLocal = ({data, token}) => {
            // set Local storage
            localStorage.setItem(dataKey, JSON.stringify(data));
            localStorage.setItem(tokenKey, token);
    }

    const delFromLocal = () => {
            localStorage.removeItem(dataKey);
            localStorage.removeItem(tokenKey);
    }

    const handleAlert = (message, appearance) => {
        addToast(message, {
            appearance: appearance,
            autoDismiss: true,
        });
    }

    if (confirmUserAccountLoading || confirmUserAuthLoading) return <LoadingSpinner />;

    return (
        <Formik
            initialValues={{ phone: '', yourFourLuckyNumber: '' }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                confirmUserWeb(values)
            }}
        >
            {({ handleSubmit }) => (
                <Form noValidate onSubmit={handleSubmit}>

                    {/*  PHONE_NUMBER */}
                    <Form.Group className="mb-3">
                        <Form.Label>ເບີໂທ: ບໍ່ໃສ່ 020 ຫລື 20 ດ້ານຫນ້າ*</Form.Label>
                        <Field
                            name="phone"
                            className="form-control"
                            type="text"
                            maxLength={8}
                            pattern="[0-9]{8}"
                            placeholder="ໃສ່ເບີໂທລະສັບ 8 ຕົວເລກ"
                        />
                        <ErrorMessage name="phone" component="small" className="text-danger" />
<br/>
                        {/*  YOUR_FOUR_LUCK_NUMBER */}
                        <Form.Label>ລະຫັດຜ່ານ*</Form.Label>
                        <Field
                            name="yourFourLuckyNumber"
                            className="form-control"
                            type="text"
                            maxLength={4}
                            pattern="[0-9]{4}"
                            placeholder="ກະລຸນາປ້ອນ 4 ຕົວເລກ"
                        />
                        <ErrorMessage name="yourFourLuckyNumber" component="small" className="text-danger" />
                    </Form.Group>

                    <div className='d-flex gap-2 justify-content-center w-100'>
                        <Button type="button"  variant='light' onClick={() => {
                            onCloseModalVerifyIdentity();
                            setIsUseLogicstics('NOT_USE_LOGICSTIC');
                        }} >ຍົກເລີກ</Button>
                        <Button type="submit" variant='info'>ຢືນຢັນ</Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
